import { generateDefaultShopStyles, ShopColors } from '../util/colorPalettes';
import { useShopConfig } from './shopConfig';

/**
 * This hook gives us access to the default styling config for shops.
 */
export function useDefaultShopStyles(): ShopColors {
  const shopConfig = useShopConfig();

  return shopConfig?.defaultShopStyles || generateDefaultShopStyles(shopConfig.css) || {};
}
